import { render } from "./ImageGallery.vue?vue&type=template&id=04289ef0&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"

import "./ImageGallery.vue?vue&type=style&index=0&id=04289ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04289ef0"]])

export default __exports__